import { Grid2 } from "@mui/material";
import React, { Fragment } from "react";
import CommonTable from "../../../candidates/Table";
import CommonAccordion from "../../../common-components/CommonAccordion";
import Notes from "../../../jobs/job-information/notes";
import Attachment from "../../../jobs/jobs-candidate/components/Attachment";
import Experience from "../../../jobs/jobs-candidate/components/Experience";
import Profile from "../../../jobs/jobs-candidate/components/Profile";
import Education from "../../../jobs/jobs-summary/components/Education";
import ExecutiveBio from "./ExecutiveBio";
import ResumeScores from "./ResumeScores";
import Skill from "./Skill";
import ClosedJobIco from "../../../../assets/icons/ClosedJobIco";
import JobReDiscovery from "../../../jobs/job-information/components/JobReDiscovery";

function ReviewCandidateProfile({
  resumeData,
  isLoading,
  handleScoreFix,
  fixLoading,
  handleDownloadResume,
  handleSaveToCandidatehub,
  handleViewCandidate,
  downloadMenuLoader,
  handleClickAddNote,
  resumeIntelligenceSave,
  notesTableList,
  notesTableListLoading,
  handleUpdateNoteClick,
  handleDeleteNoteClick,
  noteHeaderData,
  condition_based,
  handleCopyClick,
  handleCopyMouseLeave,
  copied,
  attachmentList,
  attachementHeaderData,
  handleAttachment,
  handleAttachmentTableBodyData,
  interactionHeaderdata,
  handleTableBodyData,
  handleEditCandidate,
  handleEditCandidateSubmit,
  handleEditCandidateCloseBtn,
  handleEditCandidateClose,
  statusOptions,
  handleChangeStatus,
  resumeIntelligenceCondition,
  alreadyDataHave = true,
  request_info,
  request_info_disabled,
  handleRequestInfo,
  isRequestLoading,
  profileMenuDisable,
  handleDeleteCandidate,
  deleteIconvisible,
  handleRescoreCandidate,
  handleSourceCandidate,
  bounds,
  handleGoToJob,
  handleScheduleInterview,
}) {
  const resume = [
    ...(resumeData?.elc_table?.certifications || []),
    ...(resumeData?.elc_table?.qualifications || []),
    ...(resumeData?.elc_table?.licenses || []),
    ...(resumeData?.elc_table?.research_paper || []),
  ];
  const match_data = {
    ...resumeData?.personal_details,
    ...resumeData,
    is_duplicate_present: resumeData?.is_duplicate_present,
    resume_id: resumeData?.id,
  };

  return (
    <Grid2 container spacing={4}>
      <Grid2 size={12}>
        <Profile
          isReviewCandidateProfile
          matchedData={match_data}
          filteredResumeTab={[]}
          loading={isLoading}
          resumeId={""}
          handleDownloadResume={handleDownloadResume}
          handleSaveToCandidatehub={handleSaveToCandidatehub}
          handleViewCandidate={handleViewCandidate}
          downloadMenuLoader={downloadMenuLoader}
          condition_based={condition_based}
          handleCopyClick={handleCopyClick}
          handleCopyMouseLeave={handleCopyMouseLeave}
          copied={copied}
          handleEditCandidate={handleEditCandidate}
          handleEditCandidateSubmit={handleEditCandidateSubmit}
          handleEditCandidateCloseBtn={handleEditCandidateCloseBtn}
          handleEditCandidateClose={handleEditCandidateClose}
          statusOptions={statusOptions}
          handleChangeStatus={handleChangeStatus}
          resumeIntelligenceCondition={resumeIntelligenceCondition}
          request_info={request_info}
          request_info_disabled={request_info_disabled}
          handleRequestInfo={handleRequestInfo}
          isRequestLoading={isRequestLoading}
          profileMenuDisable={profileMenuDisable}
          handleDeleteCandidate={handleDeleteCandidate}
          deleteIconvisible={deleteIconvisible}
          handleRescoreCandidate={handleRescoreCandidate}
          handleSourceCandidate={handleSourceCandidate}
          handleScheduleInterview={handleScheduleInterview}
        />
      </Grid2>

      <Grid2 size={12}>
        <CommonAccordion
          title={"Resume Scores"}
          defaultOpen={true}
          children={
            <ResumeScores
              resumeData={resumeData?.resume_score || []}
              data={resumeData}
              isLoading={isLoading}
              handleScoreFix={handleScoreFix}
              fixLoading={fixLoading}
              disabled={condition_based}
            />
          }
        />
      </Grid2>
      <Grid2 size={12}>
        <CommonAccordion
          title={"Executive Bio"}
          children={
            <ExecutiveBio
              data={resumeData?.executive_bio}
              isLoading={isLoading}
            />
          }
        />
      </Grid2>
      <Grid2 size={12}>
        <CommonAccordion
          title={" Skills"}
          children={
            <Skill
              skillData={resumeData?.all_skills || []}
              isLoading={isLoading}
            />
          }
        />
      </Grid2>
      <Grid2 size={12}>
        <CommonAccordion
          title={"Experience"}
          children={
            <Experience
              matchedData={resumeData?.job_history || []}
              isLoading={isLoading}
            />
          }
        />
      </Grid2>

      <Grid2 size={12}>
        <CommonAccordion
          title={"Education & Certifications"}
          children={<Education educationData={resume} isLoading={isLoading} />}
        />
      </Grid2>
      {alreadyDataHave && (
        <Fragment>
          <Grid2 size={12}>
            <Attachment
              tableData={attachmentList?.data}
              attachementHeaderData={attachementHeaderData}
              handleAttachment={handleAttachment}
              handleAttachmentTableBodyData={handleAttachmentTableBodyData}
              isLoading={isLoading || attachmentList?.loading}
              condition_based={condition_based}
            />
          </Grid2>

          <Grid2 size={12}>
            <CommonAccordion
              title={"Notes"}
              children={
                <Notes
                  handleClickAddNote={handleClickAddNote}
                  notesTableList={notesTableList}
                  notesTableListLoading={notesTableListLoading}
                  handleUpdateNoteClick={handleUpdateNoteClick}
                  handleDeleteNoteClick={handleDeleteNoteClick}
                  headerData={noteHeaderData}
                />
              }
            />
          </Grid2>

          <Grid2 size={12}>
            <CommonAccordion
              title={"Interactions"}
              children={
                <CommonTable
                  marginTop={"0rem"}
                  data={resumeData?.interactions}
                  loading={isLoading}
                  columns={interactionHeaderdata}
                  handleTableBodyData={handleTableBodyData}
                />
              }
            />
          </Grid2>

          {resumeData?.matched_jobs && (
            <Grid2 size={12}>
              <CommonAccordion
                title={"Matched Jobs"}
                icon={<ClosedJobIco />}
                children={
                  <JobReDiscovery
                    loading={isLoading}
                    checkWidth={bounds.width}
                    data={resumeData?.matched_jobs || []}
                    handleGoToJob={handleGoToJob}
                    type="candidate"
                  />
                }
              />
            </Grid2>
          )}
        </Fragment>
      )}
    </Grid2>
  );
}

export default ReviewCandidateProfile;
